/* eslint-disable */
// overall save the current selected window
var g_iWndIndex = 0; //don't have to set the variable; default to use the current selected window without transmiting value when the interface has window parameters

//talk
export function init(setOpenModal, setStatus, setPluginOBJ, divPlugin) {
  let oPromise = new Promise(function (resolve, reject) {
    WebVideoCtrl.I_InitPlugin({
      bWndFull: true, //Wether support doule clicking to switch the full-screen mode: it's supported by default; true:support, false:not support
      iWndowType: 1,
      bDebugMode: true,
      cbInitPluginComplete: function () {
        WebVideoCtrl.I_InsertOBJECTPlugin(divPlugin).then(
          (e) => {
            if (setPluginOBJ) {
              setPluginOBJ(e);
            }
            WebVideoCtrl.I_CheckPluginVersion().then((bFlag) => {
              if (bFlag) {
                alert('Detect the latest version, please double click HCWebSDKPlugin.exe to update!');
              }
            });
            resolve();
          },
          (e) => {
            if (setStatus) {
              setStatus(3);
            }
            if (e.errorCode === 3000) {
              console.log(e);
              if (setOpenModal) {
                setOpenModal((prev) => ({
                  ...prev,
                  status: true,
                  type: 'websdk',
                }));
              }
            }
            console.log(e);
            reject();
          }
        );
      },
    });
  });
  return oPromise;
}

export function login(ip, port, id, password) {
  return new Promise((res, rej) => {
    WebVideoCtrl.I_Login(ip, '1', port, id, password, {
      timeout: 3000,
      success: function (xmlDoc) {
        console.log(ip + ' login successful');
        res(1);
      },
      error: function (oError) {
        if (oError.errorCode === 2001) {
          // console.log(ip + ' is already login');
          res(1);
        } else {
          console.log(ip + ' login failed', oError.errorCode, oError.errorMsg);
          res(3);
        }
      },
    })
      .then(
        (e) => {
          // console.log('login then()', e);
        },
        (e) => {
          // console.log('login reject()', e);
        }
      )
      .catch((e) => {
        rej(e);
      });
  });
}

export function logout(nName) {
  if (null == nName) {
    return;
  }
  WebVideoCtrl.I_Logout(nName).then(
    () => {
      console.log(nName + ' ' + 'logout successful');
    },
    () => {
      console.log(nName + ' ' + 'logout failed');
    }
  );
}

// start voice talk
export function clickStartVoiceTalk(ip, pluginOBJ, timeoutMs = 10000) {
  let oPromise = new Promise((res, rej) => {
    let settled = false;
    const settle = (value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      res(value);
    };
    // 네트워크 단절 등으로 I_StartVoiceTalk의 콜백이 영원히 안 오는 경우를 대비한 타임아웃
    const timeoutId = setTimeout(() => {
      console.log('start voice talk timeout.', ip);
      settle(3);
    }, timeoutMs);

    var startVoiceTalk = function () {
      var szDeviceIdentify = ip,
        iAudioChannel = 1;

      if (null == szDeviceIdentify) {
        return false;
      }

      if (isNaN(iAudioChannel)) {
        alert('please select channel first.');
        return false;
      }
      WebVideoCtrl.I_StartVoiceTalk(szDeviceIdentify, iAudioChannel, pluginOBJ).then(
        () => {
          console.log('start voice talk success.');
          settle(2);
        },
        (oError) => {
          if (oError.errorCode === 16 || oError.errorCode === 21 || oError.errorCode === 0 || oError.errorCode === 4) {
            settle(4);
            return;
          }
          console.log('start voice talk error.', szDeviceIdentify, iAudioChannel, oError);

          settle(3);
        }
      );
    };
    startVoiceTalk();
  });
  return oPromise;
}

// stop voice talk
export function clickStopVoiceTalk(ip, status, pluginOBJ) {
  return new Promise((res, rej) => {
    WebVideoCtrl.I_StopVoiceTalk(ip, pluginOBJ).then(
      () => {
        console.log('stop voice talk success.', ip);
        res(status === 2 || status === 1 ? 1 : status);
      },
      (oError) => {
        console.log('stop voice talk error.', oError);
        res(3);
      }
    );
  });
}

export function clickStartVoiceTalkRelay(ip, pluginOBJ, backendUrl, sessionId) {
  return new Promise((res, rej) => {
    WebVideoCtrl.I_StartVoiceTalkRelay(ip, 1, pluginOBJ, backendUrl, sessionId).then(
      () => {
        res(2);
      },
      (oError) => {
        if (oError && (oError.errorCode === 16 || oError.errorCode === 21 || oError.errorCode === 0 || oError.errorCode === 4)) {
          res(4);
          return;
        }
        res(3);
      }
    );
  });
}

export function destroy() {
  WebVideoCtrl.I_Destory();
}
